import { combineReducers } from '@reduxjs/toolkit';

import BaselineProjectInfo from './BaselineProjectInfo';
import ProjectBudget from './ProjectBudget';
import ProjectSchedules from './ProjectSchedules';
import ProjectTeam from './ProjectTeam';
import ProjectTemplate from './ProjectTemplate';

const projectReducer = combineReducers({
  BaselineProjectInfo,
  ProjectBudget,
  ProjectTeam,
  ProjectSchedules,
  ProjectTemplate,
});

export default projectReducer;
